import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import Typography from '@mui/material/Typography';
import { useId, useMemo } from 'react';
const BASE_CHILDREN_CONTAINER_CSS = css `
  border: 2px solid black;
  border-top: none;
  border-bottom-left-radius: 14px;
  border-bottom-right-radius: 14px;
`;
const TITLE_CONTAINER_CSS = css `
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  padding: 4px 8px;
  background-color: black;
  border-top-left-radius: 14px;
  border-top-right-radius: 14px;
`;
const TITLE_CSS = css `
  font-weight: bold;
  flex-grow: 1;
`;
export const MttStagingSubSection = ({ title, children, bgColor }) => {
    const elementId = useId();
    const childrenContainerCss = useMemo(() => css(BASE_CHILDREN_CONTAINER_CSS, bgColor &&
        css `
            background-color: ${bgColor};
          `), [bgColor]);
    return (_jsxs("div", { "aria-labelledby": elementId, children: [_jsx("div", { id: elementId, css: TITLE_CONTAINER_CSS, children: _jsx(Typography, { component: 'div', css: TITLE_CSS, children: title }) }), _jsx("div", { css: childrenContainerCss, children: children })] }));
};
